<template>
	<div class="hris-page">
		<div class="hris-page-inner">
			<div class="hris-page-header">
				<span class="hris-page-eyebrow">Timekeeping</span>
				<h1 class="hris-page-title">Dashboard</h1>
				<p class="hris-page-subtitle">Monitor filed requests and employee statistics for the selected cut-off.</p>
			</div>

			<div class="hris-toolbar">
				<q-select
					v-model="month"
					:options="monthOptions"
					label="Month"
					emit-value
					map-options
					option-value="id"
					option-label="name"
					outlined
					dense
					color="green"
					style="min-width: 160px; max-width: 200px;"
					@input="fetchAllData"
				></q-select>
				<q-select
					v-model="cutoff"
					:options="cutoffOptions"
					label="Cut-off"
					emit-value
					map-options
					option-value="id"
					option-label="name"
					outlined
					dense
					color="green"
					style="min-width: 160px; max-width: 200px;"
					@input="fetchAllData"
				></q-select>
			</div>

			<div class="hris-grid" style="margin-bottom: 20px;">
				<div class="hris-stat-card dashboard-stat-card" @click="navigateToLeaves()">
					<p class="hris-stat-label"><i class="fa fa-plane-departure"></i> Vacation Leave</p>
					<p class="hris-stat-value">{{ totalVL }}</p>
				</div>
				<div class="hris-stat-card dashboard-stat-card" @click="navigateToLeaves()">
					<p class="hris-stat-label"><i class="fa fa-procedures"></i> Sick Leave</p>
					<p class="hris-stat-value">{{ totalSL }}</p>
				</div>
				<div class="hris-stat-card dashboard-stat-card" @click="navigateToLeaves()">
					<p class="hris-stat-label"><i class="fa fa-running"></i> Emergency Leave</p>
					<p class="hris-stat-value">{{ totalEL }}</p>
				</div>
				<div class="hris-stat-card dashboard-stat-card" @click="navigateToLeaves()">
					<p class="hris-stat-label"><i class="fa fa-user-tie"></i> Business Trip</p>
					<p class="hris-stat-value">{{ totalOBT }}</p>
				</div>
				<div class="hris-stat-card dashboard-stat-card" @click="navigateToLeaves()">
					<p class="hris-stat-label"><i class="fa fa-calendar-alt"></i> Change of Schedule</p>
					<p class="hris-stat-value">{{ totalCWS }}</p>
				</div>
				<div class="hris-stat-card dashboard-stat-card" @click="navigateToLeaves()">
					<p class="hris-stat-label"><i class="fa fa-user-clock"></i> Overtime</p>
					<p class="hris-stat-value">{{ totalOT }}</p>
				</div>
			</div>

			<div class="hris-panel">
				<h2 class="hris-panel-title">Employee Statistics</h2>
				<apexchart width="100%" height="300px" type="bar" :options="barchartOptions" :series="barseries"></apexchart>
			</div>

			<div class="hris-panel">
				<h2 class="hris-panel-title">For Approval</h2>
				<q-table
					:data="forApproval"
					:columns="columns"
					row-key="id"
					:pagination.sync="pagination"
					flat
				>
					<template v-slot:header="props">
						<q-tr :props="props">
							<q-th v-for="col in props.cols" :key="col.name" :props="props">
								{{ col.label }}
							</q-th>
						</q-tr>
					</template>
					<template v-slot:body="props">
						<q-tr slot="body" :props="props">
							<q-td class="text-center">
								{{ props.row.name }}
							</q-td>
							<q-td v-for="(total,j) in props.row.data" :key="j" class="text-center">
								{{ total }}
							</q-td>
						</q-tr>
					</template>
					<template v-slot:no-data>
						<div class="hris-empty">
							<span>No filed requests for this cut-off.</span>
						</div>
					</template>
				</q-table>
			</div>

			<q-dialog v-model="spinner" persistent>
				<div class="hris-loading" style="background: transparent; min-width: 120px;">
					<q-spinner color="green" size="48px"></q-spinner>
				</div>
			</q-dialog>
		</div>
	</div>
</template>
<script>
import VueApexCharts from 'vue-apexcharts';
import axios from 'axios';
import router from '../../router';

export default {
	components: {
		"apexchart" : VueApexCharts,
	},

data(){
	return {
		spinner:false,
		totalVL:0,
		totalSL:0,
		totalEL:0,
		totalOBT:0,
		totalCWS:0,
		totalOT:0,
		knobValue:0,
		whoSubmit:[],
		forApproval:[],
		columns:[],
		pagination: {
			rowsPerPage: 10
		},
		month:new Date().getMonth() + 1,
		cutoff: new Date().getDate() > 10 && new Date().getDate() < 26 ? 2 : 1,
		cutoffOptions:[{id:1,name:'First Cut-off'},{id:2,name:'Second Cut-off'}],
		monthOptions:[
		{id:1,name:'January'},
		{id:2,name:'February'},
		{id:3,name:'March'},
		{id:4,name:'April'},
		{id:5,name:'May'},	
		{id:6,name:'June'},	
		{id:7,name:'July'},
		{id:8,name:'August'},
		{id:9,name:'September'},
		{id:10,name:'October'},
		{id:11,name:'November'},	
		{id:12,name:'December'},],
		colseries:[],
		colchartOptions: {
			dataLabels: {
				enabled: false,
			},
			stroke: {
				curve: 'smooth',
			},
			xaxis: {
				type: 'datetime',
				categories: [],
			},
			tooltip: {
				x: {
					format: 'MMMM'
				},
			}
		},

		//bar graph
        barseries:[],
		barchartOptions: {
			dataLabels: {
				enabled: false,
			},
			stroke: {
				curve: 'smooth',
			},
			xaxis: {
				type: 'datetime',
				categories: [],
			},
			tooltip: {
				x: {
					format: 'MMMM'
				},
			}
		},
	}
},

created(){
	this.fetchAllData()
},

methods: {

	fetchAllData:function(){

		this.spinner = true
	  	axios.all([
	  		this.getTotalData(),
	  		this.getColumnData(),
	  		this.getKnobData(),
	  		this.getBarData(),
	  		this.getforApproval()
	  		]).then(axios.spread((total,col,knob,bar,fa) => {
	  			//for total data
				this.totalVL = total.data.data.totalVL
				this.totalSL = total.data.data.totalSL
				this.totalEL = total.data.data.totalEL
				this.totalOBT = total.data.data.totalOBT
				this.totalCWS = total.data.data.totalCWS
				this.totalOT = total.data.data.totalOT

				//for column
				this.colseries = col.data.data.barseries
				col.data.data.barcategories.forEach((res) => {
					this.colchartOptions.xaxis.categories.push(res)
				})

				//for knob data
				this.knobValue = knob.data.data.percentage
				this.whoSubmit = knob.data.data.whosubmit
		
				//for line data
				this.barseries = bar.data.data.lineSeries
				bar.data.data.lineCat.forEach((res) => {
					this.barchartOptions.xaxis.categories.push(res)
				})

				//for headers 
				this.columns = fa.data.header
				this.forApproval = fa.data.total
				 setTimeout(() => {
	                this.spinner = false
	            }, 1000);
		
		  }));
	},

	getTotalData:function()  {
  		return  axios.create({
		        baseURL: this.apiUrl,
		        headers: {
		          'Authorization': `Bearer ${this.token}`
		        }
		      }).get(`/dashboard/timekeeping/total/${this.month}/${this.cutoff}`);
	},

	getKnobData:function() {
  		return axios.create({
		        baseURL: this.apiUrl,
		        headers: {
		          'Authorization': `Bearer ${this.token}`
		        }
		      }).get(`/dashboard/timekeeping/knob/${this.month}/${this.cutoff}`);
	},

	getBarData:function() {
  		return axios.create({
		        baseURL: this.apiUrl,
		        headers: {
		          'Authorization': `Bearer ${this.token}`
		        }
		      }).get('/dashboard/employee/line');
	},

	getColumnData:function() {
  		return axios.create({
		        baseURL: this.apiUrl,
		        headers: {
		          'Authorization': `Bearer ${this.token}`
		        }
		      }).get('/dashboard/employee/bar');
	},

	getforApproval:function() {
  		return axios.create({
		        baseURL: this.apiUrl,
		        headers: {
		          'Authorization': `Bearer ${this.token}`
		        }
		      }).get(`/dashboard/timekeeping/filed/leaves/${this.month}/${this.cutoff}`);
	},

	navigateToLeaves(){
		router.push({ name: 'MyApprovals_Leave' })
	}

}
}
</script>
<style lang="css" scoped>
.dashboard-stat-card {
	cursor: pointer;
	text-align: center;
}

.dashboard-stat-card .hris-stat-label {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 6px;
}
</style>
